import * as React from 'react';
export const licenseFeeSvg = React.forwardRef(function licenseFeeSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14 12.5V14H2v-1.5h12Zm.5-.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5V14a2 2 0 0 1-1.99-1.796L0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8l-.01.204A2 2 0 0 1 14 14v-1.5a.5.5 0 0 0 .5-.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9 9V7a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1v1.5a2.5 2.5 0 0 1-2.487-2.244L5.5 9V7a2.5 2.5 0 0 1 5 0v2l-.013.256A2.5 2.5 0 0 1 8 11.5V10a1 1 0 0 0 1-1Z',
    }),
  );
});
licenseFeeSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var licenseFee = {
  category: 'icon',
  colorable: true,
  name: 'licenseFee',
  svg: licenseFeeSvg,
};
